import { Fragment, type JSX, type ReactNode } from 'react';
import {
  NavbarMenu,
  NavbarMenuBurger,
  NavbarMenuBurgerContent,
  NavbarMenuDropdown,
  NavbarMenuDropdownColumn,
  NavbarMenuDropdownItem,
  NavbarMenuItem,
  NavbarMenuList,
  NavbarMenuListGroup,
  type NavbarV2SerializableNode,
} from '..';

const componentMap = {
  navbar_menu: NavbarMenu,
  navbar_menu_list: NavbarMenuList,
  navbar_menu_list_group: NavbarMenuListGroup,
  navbar_item: NavbarMenuItem,
  navbar_dropdown: NavbarMenuDropdown,
  navbar_dropdown_column: NavbarMenuDropdownColumn,
  navbar_dropdown_item: NavbarMenuDropdownItem,
  navbar_menu_burger: NavbarMenuBurger,
  navbar_menu_burger_content: NavbarMenuBurgerContent,
};

export function getNavbarElement({
  node,
  children,
  key,
  screen,
}: {
  node: NavbarV2SerializableNode;
  children: ReactNode;
  key: string;
  screen?: string;
}): JSX.Element | null {
  let Comp: React.ComponentType<any>;

  if (!('type' in node)) {
    return null;
  }

  switch (node.type) {
    case 'navbar_item':
    case 'navbar_menu':
    case 'navbar_menu_list':
    case 'navbar_menu_list_group':
    case 'navbar_dropdown':
    case 'navbar_dropdown_column':
    case 'navbar_dropdown_item':
    case 'navbar_menu_burger':
    case 'navbar_menu_burger_content':
      Comp = componentMap[node.type];
      return (
        <Comp key={key} element={node} className={`dream-${node.type}`} screen={screen}>
          {children}
        </Comp>
      );

    default:
      return <Fragment key={key}>{children}</Fragment>;
  }
}
